"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.observeOperation = void 0;
var isArray_1 = __importDefault(require("lodash/isArray"));
var isValidPath_1 = require("./isValidPath");
var resolveValue_1 = require("./resolveValue");
var path_1 = require("../path");
var wildcard_1 = require("../wildcard");
var observeOperation = function (structure, op) {
    var path = op.path.reduce(function (acc, x) {
        var value = (0, resolveValue_1.resolveValue)(structure, x);
        if (value && value.__symbol__ === path_1.PathSymbol) {
            var expanded = value.__expand__();
            if ((0, isArray_1.default)(expanded)) {
                acc = acc.concat(expanded);
            }
        }
        else {
            if (value === wildcard_1.wildcard) {
                acc.push("*");
            }
            else {
                acc.push(value);
            }
        }
        return acc;
    }, []);
    if ((0, isValidPath_1.isValidPath)(path)) {
        var finalPath = "/" + path.join("/");
        return finalPath;
    }
    else {
        return;
    }
};
exports.observeOperation = observeOperation;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2JzZXJ2ZU9wZXJhdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ncmFwaC9vYnNlcnZlT3BlcmF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUNBLDJEQUFxQztBQUNyQyw2Q0FBNEM7QUFDNUMsK0NBQThDO0FBQzlDLGdDQUFxQztBQUNyQyx3Q0FBdUM7QUFFaEMsSUFBTSxnQkFBZ0IsR0FBRyxVQUM5QixTQUF5QixFQUN6QixFQUFvQjtJQUVwQixJQUFNLElBQUksR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxVQUFDLEdBQUcsRUFBRSxDQUFNO1FBQ3RDLElBQU0sS0FBSyxHQUFHLElBQUEsMkJBQVksRUFBQyxTQUFTLEVBQUUsQ0FBQyxDQUFDLENBQUM7UUFDekMsSUFBSSxLQUFLLElBQUksS0FBSyxDQUFDLFVBQVUsS0FBSyxpQkFBVSxFQUFFO1lBQzVDLElBQU0sUUFBUSxHQUFHLEtBQUssQ0FBQyxVQUFVLEVBQUUsQ0FBQztZQUNwQyxJQUFJLElBQUEsaUJBQU8sRUFBQyxRQUFRLENBQUMsRUFBRTtnQkFDckIsR0FBRyxHQUFHLEdBQUcsQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLENBQUM7YUFDNUI7U0FDRjthQUFNO1lBQ0wsSUFBSSxLQUFLLEtBQUssbUJBQVEsRUFBRTtnQkFDdEIsR0FBRyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQzthQUNmO2lCQUFNO2dCQUNMLEdBQUcsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUM7YUFDakI7U0FDRjtRQUNELE9BQU8sR0FBRyxDQUFDO0lBQ2IsQ0FBQyxFQUFFLEVBQVcsQ0FBQyxDQUFDO0lBRWhCLElBQUksSUFBQSx5QkFBVyxFQUFDLElBQUksQ0FBQyxFQUFFO1FBQ3JCLElBQU0sU0FBUyxHQUFHLEdBQUcsR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ3ZDLE9BQU8sU0FBUyxDQUFDO0tBQ2xCO1NBQU07UUFDTCxPQUFPO0tBQ1I7QUFDSCxDQUFDLENBQUM7QUEzQlcsUUFBQSxnQkFBZ0Isb0JBMkIzQiJ9